import { render, staticRenderFns } from "./RoundtableSettings.vue?vue&type=template&id=1fb58a8a&"
import script from "./RoundtableSettings.vue?vue&type=script&lang=js&"
export * from "./RoundtableSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports